import React from 'react';
import { TextField, type TextFieldProps } from '../../base-fields/TextField';
import { useFormField } from '../../../useFormField';
import type { StripControlledProperties } from '../../../types';

export interface TextFormFieldProps extends StripControlledProperties<TextFieldProps> {
	onChangePassThrough?: (value: string | null) => void;
}

export const TextFormField = React.memo(function FormTextField({ onChangePassThrough, ...props }: TextFormFieldProps) {
	const fieldProps = useFormField<string | null>(props);

	const onChange = (value: string | null) => {
		const newValue = value && value.length > 0 ? value : null;
		fieldProps.onChange(newValue);
		onChangePassThrough?.(newValue);
	};
	return <TextField {...props} {...fieldProps} value={fieldProps.value ?? ''} type={props.type} onChange={onChange} onBlur={fieldProps.onBlur} />;
});
